import React from 'react';

import './Radio.module.css';

// https://www.figma.com/file/hTeMNwZft7zNxdUwanR3ss/%E2%9D%96-Web-Component-Library?node-id=16%3A673
const Radio = ({ children, ...props }) => {
  return (
    <label styleName="radio">
      {children}
      <input type="radio" {...props} />
      <span styleName="dot" />
    </label>
  );
};

export default Radio;
